import { useState, useEffect } from "react";
import { sb } from "../lib/supabase";

// Phase E.1 — operator-facing Stripe Connect (Express) setup card.
// Lets an operator connect their own Stripe account so their customers pay
// them directly. Calls the connect-stripe-account function, which creates
// the Express account (first time) and returns a hosted onboarding link.
export function StripeConnectCard({ org, showToast }) {
  const [status, setStatus]   = useState(null);  // { ready, charges_enabled, ... }
  const [loading, setLoading] = useState(false);

  // If an account already exists, fetch its status (does NOT create one).
  useEffect(() => {
    if (!org?.stripe_account_id) return;
    sb.fn("connect-stripe-account", { return_url: window.location.origin })
      .then(r => { if (r && !r.error) setStatus(r); })
      .catch(() => {});
    // Surface a friendly note if we just came back from Stripe onboarding.
    if (typeof window !== "undefined" && window.location.search.includes("stripe_connect=done")) {
      showToast("Welcome back — checking your payment setup…");
    }
  }, [org?.stripe_account_id]); // eslint-disable-line react-hooks/exhaustive-deps

  async function startSetup() {
    setLoading(true);
    try {
      const r = await sb.fn("connect-stripe-account", { return_url: window.location.origin });
      if (r.error) { showToast(r.error, "error"); setLoading(false); return; }
      setStatus(r);
      if (r.ready) { showToast("Payments are already connected ✓"); setLoading(false); return; }
      if (r.onboarding_url) { window.location.href = r.onboarding_url; return; } // redirect to Stripe
      setLoading(false);
    } catch (e) { console.error(e); showToast("Could not start payment setup", "error"); setLoading(false); }
  }

  const connected = status?.ready;
  const started   = !!org?.stripe_account_id;

  return (
    <div className="card">
      <div className="card-title">💳 Payments (Stripe)</div>
      <div style={{ fontSize: 12, color: "#8993a4", marginBottom: 14 }}>
        Connect your own Stripe account so your customers’ payments go directly to you.
      </div>

      {connected ? (
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={{ fontSize: 12, background: "#e3fcef", color: "#006644", padding: "4px 10px", borderRadius: 6, fontWeight: 600, whiteSpace: "nowrap" }}>✓ Connected</span>
          <span style={{ fontSize: 12, color: "#8993a4" }}>Customers can pay you. Payouts {status?.payouts_enabled ? "enabled" : "pending"}.</span>
        </div>
      ) : (
        <div>
          {started && (
            <div style={{ fontSize: 12, color: "#974f0c", background: "#fffae6", padding: "8px 12px", borderRadius: 6, marginBottom: 12 }}>
              ⚠️ Setup not finished — you won’t be able to charge customers until it’s complete.
            </div>
          )}
          <button className="btn btn-gold" disabled={loading} onClick={startSetup}>
            {loading ? "Opening Stripe…" : started ? "Continue payment setup →" : "Connect payments →"}
          </button>
          <div style={{ fontSize: 11, color: "#8993a4", marginTop: 8 }}>
            Opens Stripe’s secure setup. In test mode you can use Stripe’s sample data.
          </div>
        </div>
      )}
    </div>
  );
}
